const SpinnerYellowIcon = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: any;
  onClick?: any;
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <g clipPath="url(#clip0_3163_18239)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00013 0.799805C8.29468 0.799805 8.53346 1.03859 8.53346 1.33314V3.9998C8.53346 4.29436 8.29468 4.53314 8.00013 4.53314C7.70558 4.53314 7.4668 4.29436 7.4668 3.9998V1.33314C7.4668 1.03859 7.70558 0.799805 8.00013 0.799805Z"
          fill="#D49D0E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1114 2.88961C13.3196 3.09789 13.3196 3.43558 13.1114 3.64386L11.178 5.57719C10.9698 5.78547 10.6321 5.78547 10.4238 5.57719C10.2155 5.36891 10.2155 5.03122 10.4238 4.82294L12.3571 2.88961C12.5654 2.68133 12.9031 2.68133 13.1114 2.88961Z"
          fill="#D49D0E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4668 8.00013C11.4668 7.70558 11.7056 7.4668 12.0001 7.4668H14.6668C14.9613 7.4668 15.2001 7.70558 15.2001 8.00013C15.2001 8.29468 14.9613 8.53346 14.6668 8.53346H12.0001C11.7056 8.53346 11.4668 8.29468 11.4668 8.00013Z"
          fill="#D49D0E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4238 10.4228C10.6321 10.2145 10.9698 10.2145 11.178 10.4228L13.1114 12.3561C13.3196 12.5644 13.3196 12.9021 13.1114 13.1104C12.9031 13.3187 12.5654 13.3187 12.3571 13.1104L10.4238 11.1771C10.2155 10.9688 10.2155 10.6311 10.4238 10.4228Z"
          fill="#D49D0E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00013 11.4668C8.29468 11.4668 8.53346 11.7056 8.53346 12.0001V14.6668C8.53346 14.9613 8.29468 15.2001 8.00013 15.2001C7.70558 15.2001 7.4668 14.9613 7.4668 14.6668V12.0001C7.4668 11.7056 7.70558 11.4668 8.00013 11.4668Z"
          fill="#D49D0E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.57621 10.4228C5.78449 10.6311 5.78449 10.9688 5.57621 11.1771L3.64288 13.1104C3.4346 13.3187 3.09691 13.3187 2.88863 13.1104C2.68035 12.9021 2.68035 12.5644 2.88863 12.3561L4.82196 10.4228C5.03024 10.2145 5.36793 10.2145 5.57621 10.4228Z"
          fill="#D49D0E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.800781 8.00013C0.800781 7.70558 1.03956 7.4668 1.33411 7.4668H4.00078C4.29533 7.4668 4.53411 7.70558 4.53411 8.00013C4.53411 8.29468 4.29533 8.53346 4.00078 8.53346H1.33411C1.03956 8.53346 0.800781 8.29468 0.800781 8.00013Z"
          fill="#D49D0E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.88863 2.88961C3.09691 2.68133 3.4346 2.68133 3.64288 2.88961L5.57621 4.82294C5.78449 5.03122 5.78449 5.36891 5.57621 5.57719C5.36793 5.78547 5.03024 5.78547 4.82196 5.57719L2.88863 3.64386C2.68035 3.43558 2.68035 3.09789 2.88863 2.88961Z"
          fill="#D49D0E"
        />
      </g>
      <defs>
        <clipPath id="clip0_3163_18239">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SpinnerYellowIcon;
